const KEY = 'cosmo_recently_viewed';
const MAX_ENTRIES = 10;
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

function safeRead() {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function safeWrite(arr) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(KEY, JSON.stringify(arr));
  } catch {
    // localStorage quota / disabled — swallow silently
  }
}

export function recordView(listing) {
  if (!listing?.id) return;
  const now = Date.now();
  const entry = {
    id: listing.id,
    city: listing.city || null,
    type: listing.type || null,
    price: typeof listing.price === 'number' ? listing.price : 0,
    bedrooms: listing.bedrooms ?? 0,
    ts: now,
  };
  const current = safeRead().filter(v => v && v.id !== listing.id);
  const next = [entry, ...current].slice(0, MAX_ENTRIES);
  safeWrite(next);
}

export function getRecentlyViewed() {
  const now = Date.now();
  const stored = safeRead();
  return stored.filter(v => v && v.ts && now - v.ts < TTL_MS);
}

function mode(values) {
  if (!values.length) return null;
  const counts = new Map();
  for (const v of values) counts.set(v, (counts.get(v) || 0) + 1);
  let best = values[0];
  let bestCount = 0;
  for (const [v, c] of counts) {
    if (c > bestCount) { best = v; bestCount = c; }
  }
  return best;
}

export function buildTasteProfile(viewed) {
  if (!viewed || viewed.length === 0) return null;
  const city = mode(viewed.map(v => v.city).filter(Boolean));
  const type = mode(viewed.map(v => v.type).filter(Boolean));
  const bedrooms = mode(viewed.map(v => v.bedrooms ?? 0)) ?? 0;
  const prices = viewed.map(v => v.price).filter(p => typeof p === 'number' && p > 0);
  const price = prices.length ? prices.reduce((a, b) => a + b, 0) / prices.length : 0;
  return { city, type, price, bedrooms };
}
